import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';

const fallbackRevenueUSD = 1_000_000;

export function useImpactDetailsRevenue() {
  const context = useNetImpactLensContext();
  if (!context) {
    return { revenue: fallbackRevenueUSD, isFallback: true };
  }
  const revenue = context.data?.revenue;
  if (!revenue || revenue <= 250_000) {
    return { revenue: fallbackRevenueUSD, isFallback: true };
  }

  return { revenue, isFallback: false };
}
